// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2nHUq","left":"StickyBox_left__3A0qu","right":"StickyBox_right__KCuv8"};